import AccountService from '@/services/AccountService'

const state = () => ({
  actual: {
    balance: 0,
    unplayed: 0,
    bonus: 0
  },
  bets: {
    data: [],
    filter: 'all'
  },
  payments: {
    data: []
  },
  profile: {
    info: []
  }
})

const getters = {}

const actions = {
  async GET_ACTUAL ({ commit }) {
    try {
      const response = await AccountService.actual()
      commit('SET_ACTUAL', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  async GET_BETS ({ commit }, { params }) {
    try {
      const response = await AccountService.bets(params)
      commit('SET_BETS', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  async GET_PAYMENTS ({ commit }, { params }) {
    try {
      const response = await AccountService.payments(params)
      commit('SET_PAYMENTS', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  async GET_PROFILE ({ commit }) {
    try {
      const response = await AccountService.profile()
      commit('SET_PROFILE', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  }
}

const mutations = {
  SET_ACTUAL (state, data) {
    state.actual.balance = data.balance
    state.actual.unplayed = data.unplayed
    state.actual.bonus = data.bonus
  },

  SET_BETS (state, data) {
    state.bets.data = data.bets.map(bet => { return Object.assign({}, bet) })
  },
  SET_BET_FILTER (state, value) {
    state.bets.filter = value
  },

  SET_PAYMENTS (state, data) {
    state.payments.data = data.payments.map(payment => { return Object.assign({}, payment) })
  },

  SET_PROFILE (state, data) {
    state.profile.info = data.info.map(item => { return Object.assign({}, item) })
  }
}

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js